module.exports = __webpack_public_path__ + "static/UNITY-SQUARE-Two-4-tenants_v2-e1c3f9cf3782fe7a066ed83425b0d357.pdf";